import React from 'react';

export default function LoadingSpinner({ size = '40px', text = 'جاري التحميل...' }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--sp-4xl)',
        gap: 'var(--sp-lg)',
      }}
    >
      <div
        style={{
          width: size,
          height: size,
          border: '4px solid var(--color-border)',
          borderTopColor: 'var(--color-primary)',
          borderRadius: '50%',
          animation: 'spinner-rotate 0.8s linear infinite',
        }}
      />
      {text && (
        <span style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--font-size-base)' }}>
          {text}
        </span>
      )}

      <style>{`
        @keyframes spinner-rotate {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
